import React, { useState, useEffect } from 'react';

function CountdownTimer({ targetDate }) {
  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: String(Math.floor((difference / (1000 * 60 * 60)) % 24)).padStart(2, '0'),
        minutes: String(Math.floor((difference / 1000 / 60) % 60)).padStart(2, '0'),
        seconds: String(Math.floor((difference / 1000) % 60)).padStart(2, '0'),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  return (
    <div className="flex flex-row mt-5 lg:mt-0" id="countdown">
      {timeLeft.days ? (
        <div className="time-container text-center mx-3">
          <div className="time text-[3rem] xl:text-[5rem] font-medium leading-none bebas">{timeLeft.days}</div>
          <div className="date-text font-light text-lg bebas">days</div>
        </div>
      ) : null}

      {timeLeft.hours ? (
        <div className="time-container text-center mx-3">
          <div className="time text-[3rem] xl:text-[5rem] font-medium leading-none bebas">{timeLeft.hours}</div>
          <div className="date-text font-light text-lg bebas">hours</div>
        </div>
      ) : null}

      {timeLeft.minutes ? (
        <div className="time-container text-center mx-3">
          <div className="time text-[3rem] xl:text-[5rem] font-medium leading-none bebas">{timeLeft.minutes}</div>
          <div className="date-text font-light text-lg bebas">minutes</div>
        </div>
      ) : null}

      {timeLeft.seconds ? (
        <div className="time-container text-center mx-3">
          <div className="time text-[3rem] xl:text-[5rem] font-medium leading-none bebas">{timeLeft.seconds}</div>
          <div className="date-text font-light text-lg bebas">seconds</div>
        </div>
      ) : null}
    </div>
  );

}

export default CountdownTimer;
